module.exports = __webpack_public_path__ + "img/vector.a9f510fa.png";